import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/baseDataZXXTZDJPJ/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/baseDataZXXTZDJPJ/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/baseDataZXXTZDJPJ/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/baseDataZXXTZDJPJ/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/baseDataZXXTZDJPJ/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/baseDataZXXTZDJPJ/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/baseDataZXXTZDJPJ/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/baseDataZXXTZDJPJ/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/baseDataZXXTZDJPJ/update/batch',
    method: 'POST',
    data})
}

   